import { useAuthToken, useSession } from '@checkatrade/auth/cjs';
import { UnauthorizedError } from 'lib/utils/errors';
import { useCallback } from 'react';

export {
  useSession,
  useIsAuthenticated,
  useAuthToken,
} from '@checkatrade/auth/cjs';

export const useUpdatedToken = () => {
  const authToken = useAuthToken();

  return useCallback(async () => {
    if (!authToken) {
      throw new UnauthorizedError();
    }

    return authToken;
  }, [authToken]);
};

/**
 * Returns true if the user is a new user
 */
export const useIsNewUser = () => {
  const session = useSession();

  return !!session.data?.user.isNewUser;
};

/**
 * Returns The user id of the current session
 */
export const useSessionUserId = () => {
  const session = useSession();

  return session.data?.user.id;
};

/**
 * Returns The user id of the current session
 */
export const useSessionUserEmail = () => {
  const session = useSession();

  return session.data?.user.email;
};
